import { Injectable } from '@angular/core';

declare var gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor() { }

  trackEvent(eventName: string, eventParams?: any) {
    const eventData = {
      ...eventParams
    };

    gtag('event', eventName, eventData);
  }
  
}
